var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D5D5D5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9C\xD0\xBE\xD1\x8F \xD0\xBA\xD0\xBE\xD0\xBB\xD0\xBB\xD0\xB5\xD0\xBA\xD1\x86\xD0\xB8\xD1\x8F"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1282,
    transform: "translate(-1256 -32)",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "header"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 88,
    transform: "translate(-1256 -32)",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6352 21.8602L17.7187 15.9194C19.2405 14.1763 20.0746 11.9697 20.0735 9.68999C20.0735 4.34701 15.5709 0 10.0367 0C4.50256 0 0 4.34701 0 9.68999C0 15.033 4.50256 19.38 10.0367 19.38C12.1143 19.38 14.0942 18.775 15.7869 17.6265L21.7483 23.6124C21.9974 23.8622 22.3326 24 22.6917 24C23.0317 24 23.3541 23.8749 23.599 23.6474C23.8488 23.4148 23.993 23.096 23.9997 22.761C24.0065 22.426 23.8754 22.102 23.6352 21.8602ZM10.0367 2.52782C14.1273 2.52782 17.4552 5.74069 17.4552 9.68999C17.4552 13.6393 14.1273 16.8522 10.0367 16.8522C5.94611 16.8522 2.61828 13.6393 2.61828 9.68999C2.61828 5.74069 5.94611 2.52782 10.0367 2.52782Z",
    fill: "#353A41"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBold);
export default __webpack_public_path__ + "static/media/search-bold.52e94b64858dd26fcc3aaa7b11f5c140.svg";
export { ForwardRef as ReactComponent };